<template>
    <CicPopup
        :save-button-label="$t('Import')"
        :saveable="lines.length > 0 && results.length === 0 && progress === 0"
        class="no-padding"
        title="Import Access Numbers"
        @blur="$emit(results.length > 0 ? 'change' : 'blur')"
        @input="validate"
    >
        <table v-if="results.length > 0" id="divImportResults" class="cic-table">
            <tbody id="tblImportResults">
                <tr v-for="(result, index) in results">
                    <td>{{ $t('Import File Row [x]').replace(/\[x]/g, (index + 1).toString()) }}</td>
                    <td>{{ result.name }}</td>
                    <td>
                        <b>{{ $t(result.result) }}</b>
                    </td>
                    <td>
                        <span
                            :class="{
                                disabled: !['OK', 'Ignored'].includes(result.result),
                                enabled: ['OK', 'Ignored'].includes(result.result),
                            }"
                        ></span>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-else-if="progress > 0" style="margin: 10px; text-align: center">
            <ElProgress type="circle" :percentage="progress" />
        </div>
        <ul v-else class="item-form" style="margin: 10px">
            <li class="form-label-first">{{ $t('Select File') }}</li>
            <li><input id="fImportFile" type="file" @change="readFile" /></li>
        </ul>
    </CicPopup>
</template>

<script>
    import { ElProgress } from 'element-plus';
    import CicPopup from '@/components/CicPopup';
    import File from '@/mixins/File';
    import { load, save } from '@/utils/Http';
    import { formatMessage, showErrorMessage, showSuccessMessage } from '@/utils/Notification';

    export default {
        name: 'ImportAccessPoints',
        components: {
            CicPopup,
            ElProgress,
        },
        mixins: [File],
        emits: ['blur', 'change'],
        data() {
            return {
                current: [],
                lines: [],
                progress: 0,
                results: [],
            };
        },
        methods: {
            fileOnLoad(content) {
                this.current = [];
                this.lines = [];
                this.progress = 0;
                this.results = [];
                try {
                    this.lines = this.parseCsv(content);
                } catch (err) {
                    showErrorMessage(this.$t('CSV_PARSE_FAILED'));
                }
            },
            importRows(start, total, size) {
                const params = { rows: JSON.stringify(this.lines.slice(start, start + size)) };
                load(
                    'accessimport/execute',
                    params,
                    (response) => {
                        this.current = this.current.concat(response.results);
                        if (start + size >= total) {
                            showSuccessMessage(formatMessage('Update successful'));
                            this.results = this.current;
                            this.progress = 0;
                        } else {
                            this.progress = Math.ceil((100 * (start + size + 1)) / (total + 1));
                            this.importRows(start + size, total, size);
                        }
                    },
                    'Saving...',
                );
            },
            validate() {
                this.progress = 1;
                save('accessimport/validate', { rows: JSON.stringify(this.lines) }, (response) => {
                    const total = parseInt(response.total);
                    this.progress = Math.ceil(100 / (total + 1));
                    this.importRows(0, total, parseInt(response.size));
                }).then((response) => {
                    if (response && response.status === 'alert') {
                        this.progress = 0;
                        this.lines = [];
                    }
                });
            },
        },
    };
</script>
